import React, { useState } from 'react';
import { Card, Input, Button } from '../../components/ui';
import { AlertTriangle, TrendingUp, Users } from 'lucide-react';
import { cn } from '../../lib/utils';

export function SportsFeeEstimatorTool() {
  const [players, setPlayers] = useState('120');
  const [games, setGames] = useState('10');
  
  const [facilityCost, setFacilityCost] = useState('75');
  const [refereeCost, setRefereeCost] = useState('50');
  
  const [uniformCost, setUniformCost] = useState('35');
  const [insuranceCost, setInsuranceCost] = useState('15');
  
  const [buffer, setBuffer] = useState('10');

  const p = parseInt(players) || 1;
  const g = parseInt(games) || 0;
  const f = parseFloat(facilityCost) || 0;
  const r = parseFloat(refereeCost) || 0;
  const u = parseFloat(uniformCost) || 0;
  const i = parseFloat(insuranceCost) || 0;
  const b = parseFloat(buffer) || 0;

  const totalGameCost = g * (f + r);
  const fixedCostPerPlayer = totalGameCost / p;
  const variableCostPerPlayer = u + i;

  const baseCost = fixedCostPerPlayer + variableCostPerPlayer;
  const finalFee = baseCost * (1 + (b / 100));

  return (
    <div className="grid lg:grid-cols-2 gap-8 text-left">
      <div className="space-y-6">
        <Card className="p-6 space-y-4">
          <h3 className="text-lg font-bold">League Scale</h3>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Total Players</label>
              <Input type="number" value={players} onChange={e => setPlayers(e.target.value)} />
            </div>
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Total Games</label>
              <Input type="number" value={games} onChange={e => setGames(e.target.value)} />
            </div>
          </div>
        </Card>
        
        <Card className="p-6 space-y-4">
          <h3 className="text-lg font-bold">Cost Breakdown</h3>
          <div className="space-y-3">
             <p className="text-[10px] uppercase font-bold text-gray-500 border-b pb-1">Per Game Costs ($)</p>
             <div className="flex gap-4"><Input placeholder="Facility/Field" type="number" value={facilityCost} onChange={e => setFacilityCost(e.target.value)} /> <Input placeholder="Referees" type="number" value={refereeCost} onChange={e => setRefereeCost(e.target.value)} /></div>
             
             <p className="text-[10px] uppercase font-bold text-gray-500 border-b pb-1 mt-4">Per Player Costs ($)</p>
             <div className="flex gap-4"><Input placeholder="Uniforms" type="number" value={uniformCost} onChange={e => setUniformCost(e.target.value)} /> <Input placeholder="Insurance" type="number" value={insuranceCost} onChange={e => setInsuranceCost(e.target.value)} /></div>
          </div>
        </Card>
      </div>

      <div className="space-y-6 flex flex-col justify-center">
        <Card className="p-6 bg-orange-50 border-orange-200 dark:bg-orange-900/20 flex flex-col justify-center h-full">
            <span className="text-[10px] uppercase font-bold block mb-2 tracking-widest text-orange-600">Calculated Registration Fee</span>
            <p className="text-6xl font-black font-mono mb-4 text-orange-700 tracking-tighter">${Math.ceil(finalFee)}</p>
            
            <div className="mt-4 pt-4 border-t border-orange-200/50">
              <label className="text-[10px] uppercase font-bold text-orange-800 block mb-2">Contingency Buffer (%)</label>
              <Input type="number" className="w-1/3 mb-4 bg-white/50 border-orange-200" value={buffer} onChange={e => setBuffer(e.target.value)} />
              
              <div className="text-sm font-mono text-orange-800 opacity-80 space-y-1">
                 <div className="flex justify-between"><span>Base Break-even Fee:</span> <span>${baseCost.toFixed(2)}</span></div>
              </div>
            </div>
        </Card>
      </div>
    </div>
  );
}

